window.Products.Accessory.ZipperCarryAll = function () {
};
window.Products.Accessory.ZipperCarryAll.inherits(window.Products.Accessory.Accessory);

window.Products.Accessory.ZipperCarryAll.id = 73;
window.Products.Accessory.ZipperCarryAll.slug = 'zipper-carry-all';
window.Products.Accessory.ZipperCarryAll.has_3d = true;
window.Products.Accessory.ZipperCarryAll.dpi = 150;

window.Products.Accessory.ZipperCarryAll.prototype.setColor = function(color, modelViewer){
	var materials = modelViewer.object.children[0].material;
	switch(color){
		case 'brass':
			materials[2].color = {r:0.55, g:0.46, b:0.29};
			materials[3].color = {r:0.48, g:0.29, b:0.19};
			materials[4].color = {r:1.00, g:0.60, b:0.40};
			materials[5].color = {r:0.75, g:0.75, b:0.75};
			break;
		case 'nickel':
			materials[2].color = {r:0.52, g:0.52, b:0.52};
			materials[3].color = {r:0.07, g:0.07, b:0.05};
			materials[4].color = {r:0.05, g:0.05, b:0.05};
			materials[5].color = {r:0.01, g:0.01, b:0.01};
			break;
	}
};

window.Products.Accessory.ZipperCarryAll.prototype.togglePull = function(pull, modelViewer) {
	modelViewer.object.children[1].visible = (pull != 'no-pull');
};

window.Products.Accessory.ZipperCarryAll.prototype.set3dProperties = function (modelViewer) {
	var me = this;
	me.updateThreeTexture(modelViewer);
	modelViewer.object.position.x = -0.05;
	modelViewer.object.position.y = -0.35;
	modelViewer.ambient_light.intensity = 0.6;
	modelViewer.object.children[0].material[0].color.setHex(16776176);
	me.loadEnvMap(function(){
		modelViewer.object.children[0].material[2].envMap = me.envMap;
		modelViewer.object.children[0].material[2].envMap.mapping = THREE.EquirectangularReflectionMapping;
		modelViewer.object.children[0].material[2].reflectivity = 0.5;
		modelViewer.object.children[0].material[2].needsUpdate = true;
		modelViewer.object.children[0].material[2].envMap.needsUpdate = true;
	});

	if(modelViewer.inlab){
		me.togglePull('no-pull', modelViewer);
	}
};

window.Products.Accessory.ZipperCarryAll.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material[0].map = modelViewer.texture;
};

window.Products.Accessory.ZipperCarryAll.prototype.setThreeControls = function (controls) {
	controls.minDistance = 2.6;
	controls.maxDistance = 5;
};